<template>
  <div class="main-content">
    <!-- 列表页 -->
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm" class="form-content">
        <!-- 搜索行 -->
        <el-row :gutter="20" class="slt" :style="{ justifyContent: searchBoxJustify }">
          <el-form-item :label="contents.inputTitle == 1 ? $t('coachManagement.coachNumber') : ''">
            <el-input
              v-model="searchForm.jiaolianbianhao"
              :placeholder="$t('coachManagement.coachNumber')"
              clearable
              :prefix-icon="inputIcon('prefix')"
              :suffix-icon="inputIcon('suffix')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="contents.inputTitle == 1 ? $t('coachManagement.coachName') : ''">
            <el-input
              v-model="searchForm.jiaolianxingming"
              :placeholder="$t('coachManagement.coachName')"
              clearable
              :prefix-icon="inputIcon('prefix')"
              :suffix-icon="inputIcon('suffix')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="search()">
              <template v-if="contents.searchBtnIcon == 1 && contents.searchBtnIconPosition == 1">
                <i class="el-icon-search"></i>
              </template>
              <span v-if="contents.searchBtnFont == 1">{{ $t('common.search') }}</span>
              <template v-if="contents.searchBtnIcon == 1 && contents.searchBtnIconPosition == 2">
                <i class="el-icon-search el-icon--right"></i>
              </template>
            </el-button>
          </el-form-item>
        </el-row>

        <!-- 操作按钮行 -->
        <el-row class="ad" :style="{ justifyContent: btnAdAllBoxJustify }">
          <el-form-item>
            <el-button v-if="isAuth('jiaolian','新增')" type="success" @click="addOrUpdateHandler()">
              <template v-if="contents.btnAdAllIcon == 1 && contents.btnAdAllIconPosition == 1">
                <i class="el-icon-plus"></i>
              </template>
              <span v-if="contents.btnAdAllFont == 1">{{ $t('common.add') }}</span>
              <template v-if="contents.btnAdAllIcon == 1 && contents.btnAdAllIconPosition == 2">
                <i class="el-icon-plus el-icon--right"></i>
              </template>
            </el-button>
            <el-button
              v-if="isAuth('jiaolian','删除') && contents.tableSelection"
              type="danger"
              @click="deleteHandler()"
              :disabled="dataListSelections.length <= 0"
            >
              <template v-if="contents.btnAdAllIcon == 1 && contents.btnAdAllIconPosition == 1">
                <i class="el-icon-delete"></i>
              </template>
              <span v-if="contents.btnAdAllFont == 1">{{ $t('common.delete') }}</span>
              <template v-if="contents.btnAdAllIcon == 1 && contents.btnAdAllIconPosition == 2">
                <i class="el-icon-delete el-icon--right"></i>
              </template>
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <!-- 数据表格 -->
      <div class="table-content">
        <el-table
          class="tables"
          :size="contents.tableSize"
          :show-header="contents.tableShowHeader"
          :header-row-style="headerRowStyle"
          :header-cell-style="headerCellStyle"
          :border="contents.tableBorder"
          :fit="contents.tableFit"
          :stripe="contents.tableStripe"
          :style="{ width: '100%', fontSize: contents.tableContentFontSize, color: contents.tableContentFontColor }"
          v-if="isAuth('jiaolian','查看')"
          :data="dataList"
          v-loading="dataListLoading"
          @selection-change="selectionChangeHandler"
        >
          <el-table-column
            v-if="contents.tableSelection"
            type="selection"
            :header-align="contents.tableAlign"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            v-if="contents.tableIndex"
            type="index"
            :label="$t('common.index')"
            :align="contents.tableAlign"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="jiaolianbianhao"
            :label="$t('coachManagement.coachNumber')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
          >
            <template slot-scope="scope">{{ scope.row.jiaolianbianhao }}</template>
          </el-table-column>
          <el-table-column
            prop="jiaolianxingming"
            :label="$t('coachManagement.coachName')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
          >
            <template slot-scope="scope">{{ scope.row.jiaolianxingming }}</template>
          </el-table-column>
          <el-table-column
            prop="xingbie"
            :label="$t('coachManagement.gender')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
          >
            <template slot-scope="scope">{{ scope.row.xingbie }}</template>
          </el-table-column>
          <el-table-column
            prop="nianling"
            :label="$t('coachManagement.age')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
          >
            <template slot-scope="scope">{{ scope.row.nianling }}</template>
          </el-table-column>
          <el-table-column
            prop="jiaoliandengji"
            :label="$t('coachManagement.level')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
          >
            <template slot-scope="scope">{{ scope.row.jiaoliandengji }}</template>
          </el-table-column>
          <el-table-column
            prop="lianxidianhua"
            :label="$t('coachManagement.phone')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
          >
            <template slot-scope="scope">{{ scope.row.lianxidianhua }}</template>
          </el-table-column>
          <el-table-column
            prop="touxiang"
            :label="$t('coachManagement.avatar')"
            :sortable="contents.tableSortable"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
            width="200"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.touxiang">
                <img :src="$base.imgurl + scope.row.touxiang.split(',')[0]" width="100" height="100">
              </div>
              <div v-else>{{ $t('common.noImage') }}</div>
            </template>
          </el-table-column>

          <!-- 新增统计列 -->
          <el-table-column prop="appointmentCount" :label="$t('coachManagement.totalAppointments')"></el-table-column>
          <el-table-column prop="lastAppointmentTime" :label="$t('coachManagement.lastAppointmentTime')"></el-table-column>
          <el-table-column prop="lastAppointmentUser" :label="$t('coachManagement.lastAppointmentUser')"></el-table-column>
          <el-table-column prop="totalIncome" :label="$t('coachManagement.totalIncome')">
            <template slot-scope="scope">
              {{ scope.row.totalIncome | formatCurrency }}
            </template>
          </el-table-column>
          
          <el-table-column
            :label="$t('common.operation')"
            :align="contents.tableAlign"
            :header-align="contents.tableAlign"
            width="300"
          >
            <template slot-scope="scope">
              <el-button
                v-if="isAuth('jiaolian','查看')"
                type="info"
                size="mini"
                @click="addOrUpdateHandler(scope.row.id, 'info')"
              >
                <template v-if="contents.tableBtnIcon == 1 && contents.tableBtnIconPosition == 1">
                  <i class="el-icon-tickets"></i>
                </template>
                <span v-if="contents.tableBtnFont == 1">{{ $t('common.detail') }}</span>
                <template v-if="contents.tableBtnIcon == 1 && contents.tableBtnIconPosition == 2">
                  <i class="el-icon-tickets el-icon--right"></i>
                </template>
              </el-button>
              <el-button
                v-if="isAuth('jiaolian','修改')"
                type="primary"
                size="mini"
                @click="addOrUpdateHandler(scope.row.id)"
              >
                <template v-if="contents.tableBtnIcon == 1 && contents.tableBtnIconPosition == 1">
                  <i class="el-icon-edit"></i>
                </template>
                <span v-if="contents.tableBtnFont == 1">{{ $t('common.edit') }}</span>
                <template v-if="contents.tableBtnIcon == 1 && contents.tableBtnIconPosition == 2">
                  <i class="el-icon-edit el-icon--right"></i>
                </template>
              </el-button>
              <el-button
                v-if="isAuth('jiaolian','删除')"
                type="danger"
                size="mini"
                @click="deleteHandler(scope.row.id)"
              >
                <template v-if="contents.tableBtnIcon == 1 && contents.tableBtnIconPosition == 1">
                  <i class="el-icon-delete"></i>
                </template>
                <span v-if="contents.tableBtnFont == 1">{{ $t('common.delete') }}</span>
                <template v-if="contents.tableBtnIcon == 1 && contents.tableBtnIconPosition == 2">
                  <i class="el-icon-delete el-icon--right"></i>
                </template>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-content"
          :layout="layouts"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="Number(contents.pageEachNum)"
          :total="totalPage"
          :small="contents.pageStyle"
          :background="contents.pageBtnBG"
          :style="{ textAlign: pagePositionText }"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加/修改页面 -->
    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";

export default {
  data() {
    return {
      searchForm: { jiaolianbianhao: "", jiaolianxingming: "" },
      form: {},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      addOrUpdateFlag: false,
      // 仅保留功能相关的配置
      contents: {
        tableSelection: true,  // 是否显示选择列
        tableIndex: true,      // 是否显示序号列
        pageEachNum: 10,        // 默认分页数量
        searchBtnFont: "1",    // 1 表示显示“查询”按钮文本
        btnAdAllFont: "1",      // 1 表示显示“新增”和“删除”按钮文本
        tableBtnFont: "1"      // 1 表示显示表格操作按钮的文本（详情、修改、删除）
      },
      layouts: ""
    };
  },
  created() {
    this.init();
    this.getDataList();
  },
  computed: {
    searchBoxJustify() {
      // 根据实际需求返回对应值
      return "flex-start";
    },
    btnAdAllBoxJustify() {
      return "flex-start";
    },
    pagePositionText() {
      // 示例：返回 left / center / right
      return "left";
    }
  },
  components: { AddOrUpdate },
  methods: {
    init() {
      // 可在此扩展其他初始化逻辑
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: "id"
      };
      if (this.searchForm.jiaolianbianhao) {
        params["jiaolianbianhao"] = "%" + this.searchForm.jiaolianbianhao + "%";
      }
      if (this.searchForm.jiaolianxingming) {
        params["jiaolianxingming"] = "%" + this.searchForm.jiaolianxingming + "%";
      }
      this.$http({
        url: "jiaolian/page",
        method: "get",
        params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const coachList = data.data.list;
          this.totalPage = data.data.total;
          // 请求所有预约数据（使用大 limit 参数获取全部记录）
          this.$http({
            url: "jiaolianyuyue/list",
            method: "get",
            params: { page: 1, limit: 9999 }
          }).then(({ data: appointmentRes }) => {
            let appointments = [];
            if (appointmentRes && appointmentRes.code === 0) {
              appointments = appointmentRes.data.list || [];
            }
            // 对每个教练统计预约数据（通过教练编号关联）
            coachList.forEach(coach => {
              const coachAppts = appointments.filter(
                appt => appt.jiaolianbianhao === coach.jiaolianbianhao
              );
              coach.appointmentCount = coachAppts.length;
              if (coachAppts.length) {
                // 取最近预约记录（按 start_time 降序排序）
                console.log("coachAppts",coachAppts);
                
                coachAppts.sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
                coach.lastAppointmentTime = coachAppts[coachAppts.length-1].startTime;
                coach.lastAppointmentUser = coachAppts[coachAppts.length-1].zhanghao;
                coach.totalIncome = coachAppts.reduce((sum, appt) => sum + (appt.price || 0), 0);
              } else {
                coach.lastAppointmentTime = "";
                coach.lastAppointmentUser = "";
                coach.totalIncome = 0;
              }
            });
            this.dataList = coachList;
            this.dataListLoading = false;
          });
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数变化
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页变化
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选变化
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id, type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      if (type !== "info") {
        type = "else";
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type);
      });
    },
    download(file) {
      window.open(`${file}`);
    },
    // 删除（支持单个与批量删除）
    deleteHandler(id) {
      const ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => Number(item.id));
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "jiaolian/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 根据 position 返回输入框图标（原来仅当 inputIcon 为 1 时使用）
    inputIcon(position) {
      // 去掉样式相关配置后，直接返回空字符串
      return "";
    }
  }
};

</script>

<style lang="scss" scoped>
.main-content {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

// 搜索区域样式
.form-content {
  margin-bottom: 20px;
  
  .slt {
    margin-bottom: 15px !important;
  
    
    .el-form-item {
      margin-right: 15px;
      margin-bottom: 0 !important;
      
      &:last-child {
        margin-right: 0;
      }
    }
    
    .el-input {
      width: 220px;
      
      ::v-deep .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        border: 1px solid #dcdfe6;
        padding: 0 15px;
        &:focus {
          border-color: #409EFF;
        }
      }
    }
    
    .el-button {
      padding: 10px 20px;
      border-radius: 18px;
    }
  }
}

// 表格区域样式
.data-table {
  width: 100%;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  
  ::v-deep {
    th {
      background-color: #f5f7fa !important;
      color: #303133;
      font-weight: 600;
    }
    
    td {
      color: #606266;
    }
    
    .cell {
      padding: 8px 12px;
    }
    
    .table-image {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 4px;
    }
  }
}

// 操作按钮样式
.el-button {
  & + .el-button {
    margin-left: 8px;
  }
  
  &--info {
    background-color: #909399;
    border-color: #909399;
  }
}

// 分页样式
.pagination {
  ::v-deep .el-pagination__jump {
    margin-left: 10px;
  }
  
  ::v-deep .btn-prev,
  ::v-deep .btn-next {
    padding: 0 12px;
  }
}
</style>